import './App.css';
import TabPanel from './TabPanel';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Myra Dotzel
        </p>
        <div>
          <TabPanel></TabPanel>
        </div>
      </header>
    </div>
  );
}

export default App;
